import { Switch as MSwitch } from '@mantine/core';
import classes from './switch.module.scss';

export const Switch = MSwitch.extend({
  classNames: classes,
});
